import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArtCategory } from '../../types';
import { artCategories } from '../../data/artworks';

interface GalleryFilterProps {
  currentFilter: ArtCategory | 'all';
  onFilterChange: (filter: ArtCategory | 'all') => void;
}

const GalleryFilter: React.FC<GalleryFilterProps> = ({ currentFilter, onFilterChange }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap gap-2 justify-center py-4">
      <button
        onClick={() => onFilterChange('all')}
        className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all ${
          currentFilter === 'all'
            ? 'bg-brand-amber text-slate-900 shadow-md shadow-brand-amber/20'
            : 'bg-white/5 text-slate-600 dark:text-slate-300 hover:bg-white/10'
        }`}
      >
        {t('art.gallery.all')}
      </button>
      
      {artCategories.map((cat) => (
        <button
          key={cat.key}
          onClick={() => onFilterChange(cat.key)}
          className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all ${
            currentFilter === cat.key
              ? 'bg-brand-amber text-slate-900 shadow-md shadow-brand-amber/20'
              : 'bg-white/5 text-slate-600 dark:text-slate-300 hover:bg-white/10'
          }`}
        >
          {t(cat.labelKey, { defaultValue: cat.key.replace('-', ' ') })}
        </button>
      ))}
    </div>
  );
};

export default GalleryFilter;
